"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
var React = require("react");
var core_1 = require("@blueprintjs/core");
var List = function (props) { return (React.createElement("ul", { className: "list center pl0 ma0" },
    props.items.map(function (item) { return props.renderItem(item); }),
    props.hasMore ?
        React.createElement("li", { id: 'load_more' },
            React.createElement("div", { className: "w-100 tc pointer pv2", onClick: props.loadMore },
                React.createElement(core_1.Button, { className: "b ba bg-white blue br2 f5-ns ph4 pv2 white", text: "Load More", minimal: true, intent: core_1.Intent.PRIMARY }))) : undefined)); };
exports.List = List;
//# sourceMappingURL=List.js.map